const radii = {
  small: ".25rem",
  medium: ".5rem",
  round: "50rem",
};

export default radii;
